import InstructionTableFilter from "./instruction-table-filter";


const InstructionFilters = {
    Table: InstructionTableFilter,
}

export default InstructionFilters;